// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Service imports
import { MPCacheRegistrationService } from '../shared-services/mp-cache-registration-service';

// Model imports
import { SystemDashboardsFactory } from '../../dashboard-module/_interfaces/system-dashboards-factory';

@Injectable()
export class DashboardsFactoryService extends SystemDashboardsFactory {
    constructor(
        protected readonly httpClient: HttpClient,
        protected readonly cacheRegistrationService: MPCacheRegistrationService
    ) {
        super(httpClient, cacheRegistrationService);
    }

    getDashboardCategoryCode(): 'USR' | 'CB' | 'COMM' | 'PROP' {
        return 'USR';
    }
}
